import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Formfields = ListFilterFieldsGeneric('Export')

export default {
  label: 'Export',
  route: 'export',
  className: 'export',
  fields: [
    {
      ...Formfields.ReferenceBySearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'),
      // not ideal since this finder isn't restricted to orga listed in leuris:Portal
      // finder: {
      //   name: 'bySearchRepLikeUnrestricted',
      //   multiValue: false,
      //   minLength: 0
      // }
      extraButton: {
        icon: 'map-marker',
        event: 'current-orga',
        tooltip: 'Export.currentOrga'
      }
    },
    Formfields.Number('jahr', 'calendar-o'),
    {
      label: 'Export.list.filter.format',
      field: 'format',
      type: 'select',
      translatable: false,
      nullable: false,
      inEditView: (_data, user) => {
        return user.roles.ADMIN === true
      },
      values: [
        { value: 'PDF', label: 'PDF' },
        { value: 'CSV', label: 'CSV' }
      ]
    },
    Formfields.String('email')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Export.js